import { app } from '../../../../../app';
import { Controller } from './manage-account-owner.controller';

app.component('companyUserDirectoriesManageAccountChangeOwner', {
    bindings: {
        account: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./manage-account-owner.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/owner/manage-account-owner.component.js